const options = {
  5: "bg-fuchsia-200/5",
  10: "bg-fuchsia-200/10",
  25: "bg-fuchsia-200/25",
  50: "bg-fuchsia-200/50",
  75: "bg-fuchsia-200/75",
  90: "bg-fuchsia-200/90",
  100: "bg-fuchsia-200",
};

const from = {
  5: "from-fuchsia-200/5",
  10: "from-fuchsia-200/10",
  25: "from-fuchsia-200/25",
  50: "from-fuchsia-200/50",
  75: "from-fuchsia-200/75",
  90: "from-fuchsia-200/90",
  100: "from-fuchsia-200",
};

export default function getBackgroundFuchsia200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
